import { render, staticRenderFns } from "./AppResourseNotFound.vue?vue&type=template&id=5850f936&scoped=true"
import script from "./AppResourseNotFound.vue?vue&type=script&lang=ts"
export * from "./AppResourseNotFound.vue?vue&type=script&lang=ts"
import style0 from "./AppResourseNotFound.vue?vue&type=style&index=0&id=5850f936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850f936",
  null
  
)

export default component.exports